import { useEffect, useState } from "react";
import { api } from "../../api/apiClient";

/**
 * G-58 — lazy, authenticated picture from the supplier's paper: the 64 px
 * thumbnail or the barcode strip. Extracted from the review table for G-129
 * so the paper page shows the same pictures with the same code.
 */
export function SupplierPicture({
  draftId,
  kind,
  alt,
  className,
}: {
  draftId: string;
  kind: "thumbnail" | "barcode";
  alt: string;
  className: string;
}) {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    let objectUrl: string | null = null;
    const load =
      kind === "thumbnail"
        ? api.fetchCatalogDraftSupplierThumbnailBlobUrl(draftId)
        : api.fetchCatalogDraftBarcodeImageBlobUrl(draftId);
    void load.then((u) => {
      if (cancelled) {
        if (u) URL.revokeObjectURL(u);
        return;
      }
      objectUrl = u;
      setUrl(u);
    });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [draftId, kind]);
  if (!url) return <div aria-hidden className={className} />;
  return <img src={url} alt={alt} className={className} loading="lazy" decoding="async" />;
}
